module.exports = __webpack_public_path__ + "media/images/favicon-120-67a644c9a084e0958daef0b0f3078b3a.png";